module.exports = __webpack_public_path__ + "img/icon-sports-black.b0c32fd1.svg";